/* Rule of 72 — Ch. 22.
   Simple, visual: doubling timeline + comparison table + inflation toggle. */
(function () {
  'use strict';
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  class RuleOf72 {
    constructor(id) {
      this.el = document.getElementById(id); if (!this.el) return;
      var u = IT.url.read();
      this.state = { rate: +u.r || 8, base: +u.b || 1000, mode: u.mode || 'growth' };
      this.render(); this.attach(); this.update();
    }
    render() {
      this.el.innerHTML = `
        <div class="sim-layout">
          <div class="sim-controls">
            <div class="sim-field">
              <label class="sim-field__label"><span data-mode-label>Annual return</span><span class="val" data-display="rate">${this.state.rate}%</span></label>
              <input type="range" data-state="rate" min="1" max="20" step="0.25" value="${this.state.rate}">
            </div>
            <div class="sim-field">
              <label class="sim-field__label"><span>Starting amount</span><span class="val" data-display="base">${fmt(this.state.base)}</span></label>
              <input type="range" data-state="base" min="100" max="100000" step="100" value="${this.state.base}">
            </div>
            <div class="sim-field">
              <span class="sim-field__label">Mode</span>
              <div class="sim-toggle" data-toggle="mode">
                <button data-val="growth" class="${this.state.mode === 'growth' ? 'is-active' : ''}">Growth</button>
                <button data-val="inflation" class="${this.state.mode === 'inflation' ? 'is-active' : ''}">Inflation</button>
              </div>
            </div>
          </div>
          <div class="sim-results">
            <div class="sim-result">
              <div class="sim-result-label" data-headline-label>Your money doubles every</div>
              <div class="sim-result-primary" data-out="doubles">— years</div>
              <div class="sim-result__sub" data-out="exact"></div>
            </div>
            <div data-out="timeline" style="display:flex; flex-wrap:wrap; gap:8px;"></div>
            <table class="sim-table">
              <thead><tr><th>Rate</th><th>Doubles in</th><th>$1k → 30 yr</th><th>$100/mo → 30 yr</th></tr></thead>
              <tbody>
                <tr><td>3%</td><td>24 yrs</td><td>$2,427</td><td>$58,419</td></tr>
                <tr><td>5%</td><td>14 yrs</td><td>$4,322</td><td>$83,226</td></tr>
                <tr><td>8%</td><td>9 yrs</td><td>$10,063</td><td>$150,030</td></tr>
                <tr><td>10%</td><td>7 yrs</td><td>$17,449</td><td>$226,049</td></tr>
                <tr><td>12%</td><td>6 yrs</td><td>$29,960</td><td>$352,991</td></tr>
              </tbody>
            </table>
          </div>
        </div>`;
      this.bindRanges();
    }
    bindRanges() {
      this.el.querySelectorAll('input[data-state]').forEach(input => {
        input.addEventListener('input', () => {
          var k = input.dataset.state, v = +input.value;
          this.state[k] = v;
          var lbl = this.el.querySelector(`[data-display="${k}"]`);
          if (lbl) lbl.textContent = (k === 'rate') ? v + '%' : fmt(v);
          this.update();
        });
      });
    }
    attach() {
      this.el.querySelectorAll('[data-toggle="mode"] button').forEach(b => {
        b.addEventListener('click', () => {
          this.state.mode = b.dataset.val;
          this.el.querySelectorAll('[data-toggle="mode"] button').forEach(x => x.classList.remove('is-active'));
          b.classList.add('is-active');
          this.update();
        });
      });
    }
    update() {
      var s = this.state;
      var num = s.mode === 'inflation' ? 70 : 72;
      var doublingT = num / s.rate;
      var exact = Math.log(2) / Math.log(1 + s.rate / 100);
      var $ = q => this.el.querySelector(q);
      $('[data-mode-label]').textContent = s.mode === 'inflation' ? 'Annual inflation' : 'Annual return';
      $('[data-headline-label]').textContent = s.mode === 'inflation' ? 'Prices double every' : 'Your money doubles every';
      $('[data-out="doubles"]').textContent = doublingT.toFixed(1) + ' years';
      $('[data-out="exact"]').textContent = `(exact: ${exact.toFixed(1)} yrs · Rule of ${num} approximation)`;

      var tl = $('[data-out="timeline"]'); tl.innerHTML = '';
      for (var i = 0; i <= 5; i++) {
        var v = s.base * Math.pow(2, i);
        var yr = Math.round(doublingT * i);
        var label = s.mode === 'inflation'
          ? `Year ${yr}: ${fmt(v)} buys what ${fmt(s.base)} buys today`
          : `Year ${yr}: ${fmt(v)}`;
        tl.insertAdjacentHTML('beforeend', `<span class="sim-pill">${label}</span>`);
      }
      IT.url.write({ r: s.rate, b: s.base, mode: s.mode });
    }
  }
  document.addEventListener('DOMContentLoaded', () => new RuleOf72('simulator-container'));
})();
